import { gql } from '@apollo/client';
import { Query } from '@apollo/client/react/components';
import * as Sentry from "@sentry/browser";
import BigNumber from "bignumber.js";
import { rgba } from "polished";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ReactComponent as IconIOST } from "../images/IconIOST.svg";
import { ReactComponent as IconVOST } from "../images/IconVOST.svg";
import {
  Balance,
  color,
  Flex,
  Hidden,
  radius,


  ScrollView, SVG, Text,
  View
} from "./Styles";
import { Tips } from "./Tips";


export default ({ screen, iostHandler, compondYearYield }) => {
  const { t } = useTranslation();
  // 资金池总金额
  const [capitalPoolBalance, setCapitalPoolBalance] = useState(0);
  // 准备金总金额
  // const [reversePoolBalance, setReversePoolBalance] = useState(0);

  useEffect(() => {
    let timerId = setInterval(
      (function x() {
        iostHandler &&
          iostHandler
            .getVOSTBalance(process.env.REACT_APP_VOST_CONTRACT_ID)
            .then(ret => {
              const { balance } = ret;
              const totalSupply = new BigNumber(
                process.env.REACT_APP_VOST_TOTAL_SUPPLY
              );
              setCapitalPoolBalance(totalSupply.minus(balance).toFixed(8));
            });
        return x;
      })(),
      10 * 1000
    );
    return () => clearInterval(timerId);
  }, [capitalPoolBalance, iostHandler]);

  // useEffect(() => {
  //   if (iostHandler) {
  //     iostHandler
  //       .getIOSTBalance(process.env.REACT_APP_VOST_CONTRACT_ID)
  //       .then(ret => {
  //         const { balance } = ret;
  //         setReversePoolBalance(Formatter.balanceNumberFormat(balance));
  //       });
  //   }
  // }, [reversePoolBalance, iostHandler]);

  const Monitor = styled(Flex)`
    > * {
      flex-shrink: 0;
      padding-right: 2em;
      :not(:last-child) {
        border-right: ${screen !== "mobile" && "1px solid " + color.border.sm};
        border-radius: ${screen === "mobile" && radius.lg};
      }
    }
  `;

  return (
    <Flex jcc aic>
      <Hidden mobile>
        <Text scale={7} bold mr={1.5} color={color.iost}>
          IOST
        </Text>
      </Hidden>

      <ScrollView>
        <Monitor aic px={[1.25, 0.25]} py={[1.5, 2]} gap={[1.25, 2]}>
          <MonitorItem
            name={t("运行监控")}
            data={t("正常运转")}
            status="normal"
          />
          <MonitorItem
            name={t("抵押矿池")}
            data={
              <>
                <SVG svg={IconIOST} withText fill={color.black} />
                {capitalPoolBalance ? (
                  <Balance amount={capitalPoolBalance} units="IOST" />
                ) : (
                    t("加载中")
                  )}
              </>
            }
          />
          <Query query={GET_TOTAL_DIVIDEND}>
            {({ loading, error, data }) => {
              if (error) {
                Sentry.captureException(error.message);
              }

              return (
                <MonitorItem
                  name={t("总结算矿利")}
                  data={
                    loading || error ? (
                      <>
                        <SVG svg={IconVOST} withText fill={color.black} />
                        {t("加载中")}
                      </>
                    ) : (
                        <>
                          <SVG svg={IconVOST} withText fill={color.black} />
                          <Balance amount={data.totalDividend} units="VOST" />
                        </>
                      )
                  }
                />
              );
            }}
          </Query>
          <MonitorItem
            name={t("季度复合年化")}
            data={
              <Flex aic gap={0.5}>
                <span>{compondYearYield}%</span>
                <Tips
                  content={[t("依据 Q3 季度每日实际结算外加 Q3 季度奖励得出")]}
                  autoWidth
                />
              </Flex>
            }
          />
        </Monitor>
      </ScrollView>
    </Flex>
  );
};

const GET_TOTAL_DIVIDEND = gql`
  {
    totalDividend
  }
`;

const MonitorItem = props => (
  <div>
    <Text scale={-2} mb={0.85} color={color.lightGray}>
      {props.name}
    </Text>
    <Flex aic>
      {props.status && <StatusBall status={props.status} mr={0.5} />}
      {props.data}
    </Flex>
  </div>
);

export const StatusBall = styled(View)`
  background: ${p => p.status === "normal" && color.green};
  box-shadow: 0 0 0 0.25em
    ${p => p.status === "normal" && rgba(color.green, 0.25)};
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 50%;
`;
